












































































































































































































































































































import { Nullable } from '@homeserve/od-typings/utils';
import {
  deploymentHelper,
  IJobOffer,
  jobHelper,
  jobOfferHelper,
  orderHelper,
  traderHelper,
} from '@homeserve/vue-api-plugin';
import moment from 'moment';
import { Component, Vue } from 'vue-property-decorator';
import { namespace } from 'vuex-class';

const jobNS = namespace('api/order/job');
const depNS = namespace('api/order/deployment');
const orderNS = namespace('api/order/order');
const traderNS = namespace('api/trader/trader');
const jobOfferNS = namespace('api/marketplace/joboffer');

@Component({
  components: {
    GenericCard: () => import('../components/cards/GenericCard.vue'),
  },
})
export default class Details extends Vue {
  @jobNS.Getter('job')
  private job!: any;

  @jobNS.Getter('jobCalls')
  private calls!: any;

  @traderNS.Getter('trader')
  private trader!: any;

  @orderNS.Getter('order')
  private order: any;

  @depNS.Getter('deployment')
  private deployment: any;

  @jobOfferNS.Getter('jobOffers')
  private jobOffers: any;

  private jobOffer: Nullable<IJobOffer> = null;
  private fab = false;
  private jobId: string = '';
  private loading = false;
  private callPagination = {
    descending: true,
    sortBy: 'callCreatedDate',
    rowsPerPage: -1,
    page: 0,
  };
  private pagination = {
    sortBy: 'id',
    descending: true,
    rowsPerPage: -1,
    page: 0,
  };

  private async created() {
    await jobHelper.setJobCalls(this.$store, []);
    await this.fetchAll();
  }

  private async fetchAll() {
    this.loading = true;
    this.jobId = this.$route.params.id;
    await this.fetchJob(this.jobId);
    await this.fetchOrder(this.job.orderId);
    const p: Array<Promise<void>> = [];
    if (this.job && this.job.lastDeployment && this.job.lastDeployment.traderEmail) {
      p.push(this.fetchTrader(this.job.lastDeployment.traderEmail));
      p.push(this.fetchDeployment(this.job.lastDeployment.id));
      p.push(this.fetchCalls(this.job.id));
    } else {
      traderHelper.resetTrader(this.$store);
    }
    if (this.job && this.job.lastDeployment) {
      p.push(this.fetchJobOffer(this.job.id));
    }
    await Promise.all(p);
    this.loading = false;
  }

  get cancellation() {
    if (this.order.status === 'canceled' || this.order.status === 'canceled_fees') {
      return this.order.cancel.reason
        ? { who: 'customer', why: this.order.cancel }
        : this.deployment && this.deployment.cancel
        ? { who: 'trader', why: this.deployment.cancel }
        : null;
    } else {
      return null;
    }
  }

  get traderComment() {
    return this.job && this.job.lastDeployment && this.job.lastDeployment.endWorkComment
      ? this.job.lastDeployment.endWorkComment
      : undefined;
  }

  get moment() {
    return (date: any) => moment(date);
  }

  get recipient() {
    if (!this.jobOffer || !this.jobOffer.recipients) {
      return;
    }

    return this.jobOffer.recipients.find(recipient => recipient.accepted === true);
  }

  private async fetchJob(jobId: string) {
    await jobHelper.fetchJob(this.$store, jobId);
  }

  private async fetchOrder(orderId: string) {
    await orderHelper.fetchOrder(this.$store, orderId);
  }

  private async fetchDeployment(deploymentId: number) {
    await deploymentHelper.fetchDeployment(this.$store, deploymentId);
  }

  private async fetchCalls(jobId: string) {
    await jobHelper.fetchJobCalls(this.$store, jobId);
  }

  private async fetchJobOffer(jobId: string) {
    await jobOfferHelper.fetchJobOffers(this.$store, {
      all: true,
      jobId,
    });

    if (this.jobOffers && this.jobOffers.data.length > 0) {
      this.jobOffer = this.jobOffers.data.pop();
    }
  }

  private async fetchTrader(traderEmail: string) {
    await traderHelper.fetchTraderByEmail(this.$store, traderEmail);
  }

  private onScroll() {
    if (typeof window === 'undefined') {
      return;
    }
    const top = window.pageYOffset || document.documentElement.offsetTop || 0;
    this.fab = top > 300;
  }
  private toTop() {
    this.$router.push({ hash: '' });
    this.$vuetify.goTo(0);
  }
}
